import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import DateTextInput from 'app/component/date-text-input';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { v4 as uuidv4 } from 'uuid';

const PaymentTemplateHistoryDialog = ({
  visible,
  onHide,
  onSave,
  payments,
  setPayments,
  paymentFrequencies,
  getYearlyPayment,
  isSaving,
  readOnly,
}) => {
  const handleInputChange = (tempId, field, value) => {
    const updatedPayments = payments.map(payment => {
      if (payment.tempId === tempId) {
        let newYearly = null;

        if (field === 'payment') {
          newYearly = getYearlyPayment(value, payment.paymentFrequency?.id);
        } else if (field === 'paymentFrequency') {
          newYearly = getYearlyPayment(payment.payment, value?.id);
        }

        if (newYearly) {
          return { ...payment, [field]: value, yearlyPayment: newYearly };
        }

        return { ...payment, [field]: value };
      }

      return payment;
    });

    setPayments(updatedPayments);
  };

  const addNewPayment = () => {
    const newPayment = {
      tempId: uuidv4(), // Generate a new temporary ID
      payment: null,
      paymentFrequency: {},
      validFrom: null,
      validTo: null,
    };
    setPayments([...payments, newPayment]);
  };

  const deletePayment = tempId => {
    const updatedPayments = payments.filter(payment => payment.tempId !== tempId);
    setPayments(updatedPayments);
  };

  const handleSave = () => {
    onSave(payments);
  };

  const actionBodyTemplate = rowData => {
    return <Button icon="pi pi-trash" disabled={isSaving} className="p-button-danger" onClick={() => deletePayment(rowData.tempId)} />;
  };

  return (
    <Dialog header="História platobných predpisov" visible={visible} style={{ width: '90vw' }} onHide={onHide}>
      <DataTable stripedRows emptyMessage="Žiadne predpisy" disabled={isSaving} value={payments} responsiveLayout="scroll">
        <Column
          field="payment"
          header="Lehotná platba"
          body={rowData => (
            <InputNumber
              value={rowData.payment}
              readOnly={readOnly}
              locale="sk"
              minFractionDigits={0}
              maxFractionDigits={2}
              onChange={e => {
                handleInputChange(rowData.tempId, 'payment', e.value);
              }}
            />
          )}
        />
        <Column
          field="paymentFrequency"
          header="Frekvencia platenia"
          body={rowData => (
            <Dropdown
              value={rowData.paymentFrequency?.id}
              options={paymentFrequencies}
              optionLabel="label"
              disabled={readOnly}
              onChange={e => {
                handleInputChange(rowData.tempId, 'paymentFrequency', { id: e.value });
              }}
              placeholder="Vyberte frekvenciu platenia"
            />
          )}
        />
        <Column
          field="yearlyPayment"
          header="Ročná platba"
          body={rowData => <InputNumber disabled={true} value={rowData.yearlyPayment} locale="sk" minFractionDigits={0} maxFractionDigits={2} />}
        />
        <Column
          field="validFrom"
          header="Validné od"
          body={rowData => (
            <DateTextInput
              value={rowData.validFrom}
              onChange={val => handleInputChange(rowData.tempId, 'validFrom', val)}
              readOnly={readOnly}
            />
          )}
        />
        <Column
          field="validTo"
          header="Validné do"
          body={rowData => (
            <DateTextInput
              value={rowData.validTo}
              onChange={val => handleInputChange(rowData.tempId, 'validTo', val)}
              readOnly={readOnly}
            />
          )}
        />
        {!readOnly && <Column body={actionBodyTemplate} header="Akcie" />}
      </DataTable>
      {!readOnly && (
        <Button
          style={{ backgroundColor: '#e31818' }}
          label="Pridať nový predpis"
          disabled={isSaving}
          icon="pi pi-plus"
          onClick={addNewPayment}
        />
      )}
      {!readOnly && (
        <div style={{ marginTop: '1rem', textAlign: 'right' }}>
          <Button style={{ backgroundColor: '#e31818' }} disabled={isSaving} label="Uložiť" icon="pi pi-check" onClick={handleSave} />
        </div>
      )}
    </Dialog>
  );
};

export default PaymentTemplateHistoryDialog;
